module.exports = __webpack_public_path__ + "static/media/33-giftige.96741b75.mp3";